module.exports = __webpack_public_path__ + "static/media/error.582e40f3.mp3";